import type { CSSProperties } from 'react';
import { FormGroup, Row } from '@ksyos/design-system';
import type {
    IAfwijkingen,
    IAfwijkingenWithOdAndOs,
} from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1DiagnosticReportCustomControlData';
import { AfwijkingenInputCheckboxOsAndOd } from './AfwijkingenInputCheckboxOsAndOd';

interface IAfwijkingenCheckboxGroupRowProps<K> {
    afwijkingen: IAfwijkingenWithOdAndOs;
    handleChangeAfwijkingen: (key: keyof K, value: K[keyof K]) => Promise<void>;
    label: string;
    overarchingKey: string;
    style?: CSSProperties;
}

export function AfwijkingenCheckboxGroupRow(props: IAfwijkingenCheckboxGroupRowProps<IAfwijkingen>) {
    const { overarchingKey, label, afwijkingen, style, handleChangeAfwijkingen } = props;

    const key_od = `${overarchingKey}_od` as keyof IAfwijkingenWithOdAndOs;
    const key_os = `${overarchingKey}_os` as keyof IAfwijkingenWithOdAndOs;

    return (
        <FormGroup label={label}>
            <Row style={style}>
                <AfwijkingenInputCheckboxOsAndOd
                    afwijkingen={afwijkingen}
                    handleChangeAfwijkingen={handleChangeAfwijkingen}
                    key_od={key_od}
                    key_os={key_os}
                />
            </Row>
        </FormGroup>
    );
}
